import { InputWithInsetLabel } from '../../../../DanitComponents/Inputs/InputWithInsetLabel'
import {Controller} from 'react-hook-form';
import InputMask from 'react-input-mask'
import { statusStyles, statusOptions } from '../../../studentmodal2023utils'
import { MdClose } from 'react-icons/md';
import './student-info-tab-center-gutter.css'
import { getRequestHeaders } from '../../../../api';
import axios from 'axios';
import { baseUrl } from '../../../../assets/Animations';

const StudentInfoTabCenterGutter = ({family, setFamily, instrumentList, teachers}) => {

    const handleStudentInfoChange = (e, inputType, index) => {
        let newStudents = [...family.students]
        newStudents[index][inputType] = e.target.value
        setFamily({...family, students: newStudents})
    }

    const studentStatusChange = (e, index) => {
        let newStudents = [...family.students]

        let message = `*${newStudents[index].studentName} ${family.familyName}* has been changed from *${newStudents[index].studentStatus}* to *${e.target.value}*`
        axios.post(`${baseUrl}/atharo-slack/${family.school.toLowerCase()}`, {message: message}, getRequestHeaders())

        newStudents[index].studentStatus = e.target.value
        setFamily({...family, students: newStudents})

    }

    const changeLessonRates = (e, lengthNumter, index) => {
        let newStudents = [...family.students]
        newStudents[index].allRates[lengthNumter] = e.target.value
        setFamily({...family, students: newStudents})
    }

    const addInstrumentToStudent = (id, index) => {
        let newStudents = [...family.students]
        let instrument = instrumentList.find(instrument => instrument.id === id)
        newStudents[index].instrumentList.push(instrument)
        setFamily({...family, students: newStudents})
    }

    const removeInstrumentFromStudent = (id) => {
        let newStudents = [...family.students]
        newStudents.forEach(student => {
            student.instrumentList = student.instrumentList.filter(instrument => instrument.id !== id)
        })
        setFamily({...family, students: newStudents})
    }

    const addStudent = () => {
        let newStudents = [...family.students]
        newStudents.push({
            studentId: Math.random().toString(16).slice(2),
            studentName: "",
            dob: "",
            instrument: "",
            instrumentList: [],
            teachersId: "",
            lessonLength: 0,
            lessonRate: 0,
            allRates: {15: 26, 30: 49, 45: 64, 60: 79},
            studentStatus: "Being Onboarded",
            studentNotes: "",
          })
        setFamily({...family, students: newStudents})
    }

    const removeStudent = (index) => {
        let newStudents = [...family.students]
        newStudents.splice(index, 1)
        setFamily({...family, students: newStudents})
    }

    const isDateValid = (value) => {
        const date = new Date(value);
        const currentDate = new Date();
        const minDate = new Date();
        minDate.setFullYear(currentDate.getFullYear() - 100); // Limit age to 100 years
    
        return !isNaN(date.getTime()) && date <= currentDate && date >= minDate;
      };

    return (
        <div className="student-info-tab-center-gutter__wrapper">
            {family.students.map((student, index) => (
                <div className='family-info-tab-center-gutter__each-student__wrapper'>
                    <div className='family-info-tab-center-gutter__top-label__wrapper'>
                        <div className='family-info-tab-center-gutter__top-label__line'></div>
                        <div className='family-info-tab-center-gutter__top-label__words'>STUDENT #{index + 1}</div>
                        <div className='family-info-tab-center-gutter__top-label__line'></div>
                    </div>
                    <div className='student-info-tab-center-gutter__status__wrapper'>
                        <select className='student-info-tab-center-gutter__student-status' style={statusStyles(student.studentStatus)} onChange={(e) => studentStatusChange(e, index)} value={student.studentStatus} >
                            {statusOptions.map(status => <option value={status.value}>{status.label}</option>)}
                        </select>
                        <MdClose className='student-info-tab-center-gutter__remove-student' onClick={() => removeStudent(index)} color='rgb(51, 65, 85)' size={20} />
                    </div>
                    
                    <div className='student-info-tab-center-gutter__input'>
                        <InputWithInsetLabel key={index} label={'First Name'} changeFunction={(e) => handleStudentInfoChange(e, 'studentName', index)} value={student['studentName']} />
                    </div>
                    <div className='student-info-tab-center-gutter__input'>
                        <InputWithInsetLabel key={index} label={'Last Name'} changeFunction={(e) => handleStudentInfoChange(e, 'familyName', index)} value={family['familyName']} />
                    </div>
                    <div className='student-info-tab-center-gutter__input'>
                        <div className='student-info-tab-center-gutter__date-input__label'>DOB</div>
                        {/* <InputWithInsetLabel key={index} label={'DOB'} changeFunction={(e) => handleStudentInfoChange(e, 'dob', index)} value={student['dob']} /> */}
                        <InputMask
                          className='student-info-tab-center-gutter__date-input'
                          mask="99/99/9999"
                          value={student['dob']}
                          onChange={(e) => handleStudentInfoChange(e, 'dob', index)}
                          id={`student-dob-${index}`}
                          maskPlaceholder="mm/dd/yyyy"
                          alwaysShowMask
                          placeholder="Student's birthday (mm/dd/yyyy)"
                        >
                          {(inputProps) => <input {...inputProps} />}
                    </InputMask>
                    </div>

                    <div className='student-info-tab-center-gutter__input'>
                    <div className='student-info-tab-center-gutter__teacher-input__label'>Experience Level</div>
                        <select className='student-info-tab-center-gutter__dropdown-input' onChange={(e) => handleStudentInfoChange(e, 'experienceLevel', index)} value={student['experienceLevel']}>
                            <option value=''>Student's experience level</option>
                            <option value="no experience">First Time</option>
                            <option value="1 year">1 year</option>
                            <option value="2 years">2 years</option>
                            <option value="+2 years">+2 years</option>
                            <option value="3 years">3 years</option>
                            <option value="4 years">4 years</option>
                            <option value="5 years">5 years</option>
                            <option value="6 years">6 years</option>
                            <option value="7 years">7 years</option>
                            <option value="8 years">8 years</option>
                            <option value="9 years">9 years</option>
                            <option value="10 years">10 years</option>
                        </select>
                    </div>
                    <div className='student-info-tab-center-gutter__input'>
                    <div className='student-info-tab-center-gutter__teacher-input__label'>Instrument</div>
                        <select className='student-info-tab-center-gutter__dropdown-input' onChange={(e) => addInstrumentToStudent(e.target.value, index)} value={''}>
                            <option value=''>Add an instrument</option>
                            {instrumentList.map((instrument, index) => (
                                <option key={index} value={instrument.id}>{instrument.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className='student-info-tab-center-gutter__input'>
                        <div className='student-info-tab-center-gutter__teacher-input__label'>Teacher</div>
                        <select className='student-info-tab-center-gutter__dropdown-input' onChange={(e) => handleStudentInfoChange(e, 'teachersId', index)} value={student.teachersId}>
                            <option value=''>Find a teacher</option>
                            {teachers.map((teacher, index) => (
                                <option key={index} value={teacher.TeacherID}>{teacher.Name}</option>
                            ))}
                        </select>
                    </div>
                    <div className='student-info-tab-center-gutter__instrument-chip__wrapper'>
                        {student.instrumentList.map((instrument, index) => (
                        <div key={index} className='student-info-tab-center-gutter__instrument-chip'>
                            <div>{instrument.name}</div>
                            <div className='student-info-tab-center-gutter__instrument-chip__x' onClick={() => removeInstrumentFromStudent(instrument.id)}>x</div>    
                        </div>
                        ))}
                    </div>
                    <div className='student-info-tab-center-gutter__input__lesson-length'>
                    <div className='student-info-tab-center-gutter__teacher-input__label'>Lesson Length</div>
                        <select className='student-info-tab-center-gutter__dropdown-input' onChange={(e) => handleStudentInfoChange(e, 'lessonLength', index)} value={student.lessonLength}>
                            <option value=''>Choose lesson length</option>
                            <option value={'15'}>15 min</option>
                            <option value={'30'}>30 min</option>
                            <option value={'45'}>45 min</option>
                            <option value={'60'}>60 min</option>
                        </select>
                    </div>
                    <div className='student-info-tab-center-gutter__mini-input__wrapper'>
                        <div className='student-info-tab-center-gutter__mini-input'>
                            <InputWithInsetLabel label={'15 min'} changeFunction={(e) => changeLessonRates(e, 15, index)} value={student.allRates[15]} />
                        </div>
                        <div className='student-info-tab-center-gutter__mini-input'>
                            <InputWithInsetLabel label={'30 min'} changeFunction={(e) => changeLessonRates(e, 30, index)} value={student.allRates[30]} />
                        </div>
                        <div className='student-info-tab-center-gutter__mini-input'>
                            <InputWithInsetLabel label={'45 min'} changeFunction={(e) => changeLessonRates(e, 45, index)} value={student.allRates[45]} />
                        </div>
                        <div className='student-info-tab-center-gutter__mini-input'>
                            <InputWithInsetLabel label={'60 min'} changeFunction={(e) => changeLessonRates(e, 60, index)} value={student.allRates[60]} />
                        </div>
                    </div>
                </div>
            ))}
            <div>
                <div className='student-info-tab-center-gutter__add-student-btn' onClick={() => addStudent()}>+ Add a student</div>
            </div>
        </div>
    )
}
export default StudentInfoTabCenterGutter